import React from 'react'
import { ConfigProvider } from 'antd'
import avaLogo from '@/assets/logos/ava-logo.png'
import blueBg from '@/assets/backgrounds/blue-polygon.png'
import FlashMessages from '@/components/FlashMessages'

interface LoginLayoutProps {
  children: React.ReactNode
  title?: string
}

export default function LoginLayout({ children, title }: LoginLayoutProps) {
  return (
    <ConfigProvider componentSize="small">
      <div
        className="min-h-screen w-full flex flex-col bg-cover bg-center"
        style={{ backgroundImage: `url(${blueBg})` }}
      >
        <FlashMessages />
        <div className="h-14 w-full bg-white flex items-center px-12 justify-between">
          <div className="flex items-center">
            <img
              src={avaLogo}
              alt="AVA"
              className="transition-opacity duration-300 h-14"
            />
          </div>
          <div className="flex items-center">
            <span className="text-gray-900 text-sm font-medium">{title}</span>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center flex-1 transition-opacity duration-500">
          {children}
        </div>
      </div>
    </ConfigProvider>
  )
}
